import React from 'react';

// PRD-020 F2 — small reusable destructive-action confirm modal. Used for the
// hard-delete of an unsigned Proposal (Proposals list + Proposal detail). Kept
// generic (title/message/confirm copy) so other destructive flows can reuse it.
export default function ConfirmDialog({
  open,
  title = 'Are you sure?',
  message,
  confirmLabel = 'Delete',
  cancelLabel = 'Cancel',
  destructive = true,
  busy = false,
  onConfirm,
  onCancel,
}) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
      onMouseDown={(e) => { if (e.target === e.currentTarget && !busy) onCancel(); }}
    >
      <div className="card max-w-md w-full p-6" role="dialog" aria-modal="true">
        <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
        {message && <p className="text-sm text-gray-600 mt-2">{message}</p>}
        <div className="flex justify-end gap-3 mt-6">
          <button className="btn-secondary" onClick={onCancel} disabled={busy}>{cancelLabel}</button>
          <button
            className={destructive ? 'btn-danger' : 'btn-primary'}
            onClick={onConfirm}
            disabled={busy}
          >
            {busy ? 'Working…' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
